// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"689":"08a1d4b5","958":"ddec6189"}[chunkId] + ".js";
};